module.exports = __webpack_public_path__ + "28aab2a639741aaa55535b4b7a8f36b6.png";